(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    // Populate mobile actions select from desktop buttons
  document.addEventListener('DOMContentLoaded', () => {
    const desktopContainer = document.querySelector('.collection-header-actions');
    const select = document.getElementById('collection-actions-select');
    const mobileWrapper = document.querySelector('.collection-header-actions-mobile');
    if (!desktopContainer || !select || !mobileWrapper) return;

    const links = desktopContainer.querySelectorAll('a[href]');
    links.forEach((a) => {
      const opt = document.createElement('option');
      opt.value = a.getAttribute('href');
      opt.textContent = a.textContent.trim();
      opt.dataset.target = a.getAttribute('target') || '';
      select.appendChild(opt);
    });

    // Show the first button label as the placeholder text instead of generic "Actions"
    if (select.options.length > 1) {
      const placeholder = select.options[0];
      const firstButton = select.options[1];
      if (placeholder && firstButton) {
        placeholder.textContent = firstButton.textContent;
      }
    }

    // If only placeholder option exists, hide the mobile wrapper
    if (select.options.length <= 1) {
      mobileWrapper.style.display = 'none';
      return;
    }

    select.addEventListener('change', (e) => {
      const url = select.value;
      const selected = select.options[select.selectedIndex];
      const target = selected?.dataset?.target;
      if (!url) return;
      if (target === '_blank') {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
